import { useEffect } from 'react';
import { KeyCombinations, useWindowKeyDown } from '../GraphicEditorHelpers';

export const useKeyboardShortcuts = ({
  selectedGroup,
  stage,
  copyElement,
  deleteElement,
  createGroup,
  destroyGroup,
  historyUndoAction,
  historyRedoAction,
}) => {
  const [keyFired, setKeyFiredProcessed] = useWindowKeyDown();

  useEffect(() => {
    if (!keyFired) return;

    if (keyFired === KeyCombinations.ctrlG) {
      const isGroupSelected =
        selectedGroup &&
        selectedGroup.attrs.elementType === 'group' &&
        selectedGroup.hasName('elementGroup');
      if (isGroupSelected) {
        destroyGroup(selectedGroup);
      } else {
        createGroup();
      }
    }
    if (keyFired === KeyCombinations.ctrlD) {
      copyElement(selectedGroup);
    }
    if (
      keyFired === KeyCombinations.delete ||
      keyFired === KeyCombinations.backspace
    ) {
      deleteElement(selectedGroup);
    }
    if (keyFired === KeyCombinations.ctrlZ) {
      historyUndoAction(stage);
    }
    if (keyFired === KeyCombinations.ctrlY) {
      historyRedoAction(stage);
    }

    setKeyFiredProcessed();
  }, [keyFired]);
};
